export default "__VITE_ASSET__Bgae0VjM__"